import React, { Fragment } from "react";
import { Card } from "semantic-ui-react";

/**
 * @author
 * @function Cards
 **/

const Cards = ({ item, history }) => {
  return (
    <Fragment>
      <Card
        style={cardStyle}
        onClick={() => (window.location.href = item.link)}
      >
        <Card.Content>
          <Card.Header style={itemHeader}>{item.name}</Card.Header>
          <Card.Description>
            <p style={textStyle}>{item.description.substr(0,250)}</p>
          </Card.Description>
          <p style={feedStyle}>
            {/* <TimeLogo /> &nbsp; */}
            Type |<span style={{ color: "green" }}> {item.type}</span>
          </p>
        </Card.Content>
      </Card>
    </Fragment>
  );
};

export default Cards;
const cardStyle = {
  width: "100%",
  height: "123px",
  marginBottom: "10px",
  borderRadius: "12px",
  boxShadow: "0px 3px 28px rgba(0, 0, 0, 0.08)"
};
const textStyle = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  fontSize: "10px"
};
const feedStyle = {
  position: "absolute",
  marginBottom: "10px",
  bottom: "0",
  fontWeight: "normal",
  fontSize: "8px",
  color: "rgba(0, 0, 0, 0.5)"
};
const itemHeader = { fontSize: "12px", fotnWeight: "bold" ,color : "#FBC91B"};
